module.exports = __webpack_public_path__ + "static/img/Chloe-Logarzo.67a42d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chloe-Logarzo.jpg
// module id = kuev
// module chunks = 0